var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "grow", attrs: { flat: "" } },
    [
      _c(
        "v-card",
        { staticClass: "grow mb-4", attrs: { outlined: "" } },
        [
          _c("NodalPCQuickLook", {
            attrs: {
              "case-outputs": _vm.caseOutputs,
              "input-case": _vm.inputCase,
              horizontal: true,
              selectedTab: _vm.selectedTab,
              selectedNodeId: _vm.selectedNodeId,
            },
          }),
        ],
        1
      ),
      _vm.viewMode === "dashboard"
        ? _c(
            "v-card",
            { staticClass: "grow", attrs: { flat: "" } },
            [
              _c("NodalPCDashboard", {
                attrs: {
                  "case-outputs": _vm.caseOutputs,
                  "input-case": _vm.inputCase,
                  selectedTab: _vm.selectedTab,
                  selectedNodeId: _vm.selectedNodeId.nodeId,
                },
              }),
            ],
            1
          )
        : _c(
            "v-card",
            { staticClass: "grow", attrs: { flat: "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("NodalPCTabular", {
                    attrs: {
                      "case-outputs": _vm.caseOutputs,
                      "input-case": _vm.inputCase,
                      selectedTab: _vm.selectedTab,
                      selectedNodeId: _vm.selectedNodeId,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }